import React from 'react';
import { MdExitToApp, MdSupervisorAccount, MdNotifications, MdSettings } from 'react-icons/md';

const Header = ({ user, handleLogout }) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '15px 0',
      borderBottom: '2px solid #e0e0e0',
      marginBottom: 20,
      backgroundColor: '#fff',
      borderRadius: 8,
      paddingLeft: 20,
      paddingRight: 20,
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      {/* Left side - SuperAdmin Info */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>

        <div>
          <h1 style={{
            margin: 0,
            fontSize: 24,
            fontWeight: 'bold',
            color: '#1976d2'
          }}>
            SuperAdmin Dashboard
          </h1>
          <p style={{
            margin: 0,
            fontSize: 14,
            color: '#666',
            fontWeight: 'normal'
          }}>
            System-wide Revenue Management
          </p>
        </div>
      </div>

      {/* Right side - User Actions */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
        {/* User Info */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: '8px 16px',
          backgroundColor: '#f8f9fa',
          borderRadius: 8,
          border: '1px solid #e9ecef'
        }}>
          <div style={{ textAlign: 'right' }}>
            <div style={{
              fontSize: 14,
              fontWeight: '600',
              color: '#1976d2',
              marginBottom: 2
            }}>
              {user?.username || user?.full_name || ''}
            </div>
            <div style={{
              fontSize: 12,
              color: '#6c757d',
              textTransform: 'capitalize'
            }}>
              {user?.role_name?.replace('_', ' ') || 'Super Admin'}
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <button
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 8,
              borderRadius: 6,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f8f9fa'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
            title="Notifications"
          >
            <MdNotifications size={20} style={{ color: '#6c757d' }} />
          </button>

          <button
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 8,
              borderRadius: 6,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f8f9fa'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
            title="Settings"
          >

          </button>

          <button
            onClick={handleLogout}
            style={{
              background: 'none',
              border: '1px solid #dc3545',
              cursor: 'pointer',
              padding: '8px 12px',
              borderRadius: 6,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              color: '#dc3545',
              fontSize: 14,
              fontWeight: '500',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#dc3545';
              e.currentTarget.style.color = 'white';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#dc3545';
            }}
            title="Logout"
          >
            <MdExitToApp size={16} />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;